import { jsx as o } from "react/jsx-runtime";
import a from "react";
import s, { css as h } from "styled-components";
import { e as v, d as w } from "../chunks/vendor_rango__tokens.38ee67b0.js";
const b = {
  Compact: "compact",
  Comfortable: "comfortable"
}, m = {
  Auto: "auto",
  Fixed: "fixed"
};
Object.values(b);
const f = s.td.withConfig({
  displayName: "Cell",
  componentId: "sc-brjk6h-0"
})(["", " height:var(--size-8x);min-width:160px;border:var(--default-border-width) solid var(--elements-border-color);padding:var(--spacing-none) var(--spacing-3x);span{display:flex;align-items:center;color:var(--text-label-color);}", " ", " ", " border-right:none;border-left:none;&:last-of-type{border-top-right-radius:var(--default-border-radius);border-bottom-right-radius:var(--default-border-radius);border-left:none;border-right:var(--default-border-width) solid var(--elements-border-color);}&:first-of-type{border-top-left-radius:var(--default-border-radius);border-bottom-left-radius:var(--default-border-radius);border-right:none;border-left:var(--default-border-width) solid var(--elements-border-color);}"], v, ({
  $isCompact: e
}) => e && "min-width: fit-content; width: auto;", ({
  $fixed: e
}) => e && `width: ${e}; min-width: 0;`, (e) => e.$paddingLg === !1 && "padding: var(--spacing-none) var(--spacing-1_5x);"), u = s.th.withConfig({
  displayName: "TableHead",
  componentId: "sc-j5hrzs-0"
})(["", " text-align:left;height:var(--size-6x);min-width:160px;vertical-align:middle;padding:var(--spacing-none) var(--spacing-3x);span{display:flex;align-items:center;color:var(--text-label-color);}", " ", " ", ""], w, ({
  $isCompact: e
}) => e && "min-width: fit-content; width: auto;", ({
  $fixed: e
}) => e && `width: ${e}; min-width: 0;`, (e) => e.$paddingLg === !1 && "padding: var(--spacing-none) var(--spacing-1_5x);"), x = s.table.withConfig({
  displayName: "Table",
  componentId: "sc-1qij6if-0"
})(["display:table;width:100%;border-spacing:0px ", ";", ";", ";", " ", ""], ({
  $ghost: e
}) => e ? "0px" : "var(--spacing-1x)", ({
  $layout: e
}) => e === m.Fixed && "width: auto", ({
  $layout: e
}) => e && `table-layout: ${e}`, ({
  $ghost: e
}) => e && h(["", ",", "{padding:0px;border:var(--border-width-none);}"], f, u), ({
  $density: e
}) => e === b.Comfortable && h(["", "{height:var(--size-10x);}"], f)), C = s.div.withConfig({
  displayName: "TableOverflowContainer",
  componentId: "sc-1qij6if-1"
})(["overflow-x:auto;"]), R = s.tbody.withConfig({
  displayName: "TableBody",
  componentId: "sc-1qij6if-2"
})([""]), T = a.forwardRef(({
  ghost: e = !1,
  density: t = b.Comfortable,
  tableLayout: r = m.Auto,
  children: n,
  ...d
}, l) => /* @__PURE__ */ o(C, { children: /* @__PURE__ */ o(x, { ref: l, ...d, $ghost: e, $density: t, $layout: r, "data-rango-component": "rango-table", "data-is-rango": !0, children: /* @__PURE__ */ o(R, { children: n }) }) }));
T.displayName = "RangoTable";
const N = a.forwardRef(({
  children: e,
  isCompact: t,
  fixed: r,
  ...n
}, d) => {
  const [l, c] = a.useState(!0);
  a.useEffect(() => {
    p();
  }, []);
  const p = () => {
    const i = a.Children.toArray(e)[0];
    if (a.isValidElement(i) && i.type !== void 0) {
      const {
        displayName: g
      } = i.type;
      ["RangoButtonIcon", "RangoRadioButton", "RangoCheckbox"].includes(g) && c(!1);
    }
  };
  return /* @__PURE__ */ o(f, { width: 2e3, ref: d, $paddingLg: l, $fixed: r, $isCompact: t, ...n, children: /* @__PURE__ */ o("span", { children: e }) });
});
N.displayName = "RangoTableCell";
const $ = a.forwardRef(({
  children: e,
  ...t
}, r) => /* @__PURE__ */ o("tr", { ref: r, ...t, children: e }));
$.displayName = "RangoTableRow";
const L = a.forwardRef(({
  children: e,
  isCompact: t,
  fixed: r,
  ...n
}, d) => {
  const [l, c] = a.useState(!0);
  a.useEffect(() => {
    p();
  }, [e]);
  const p = () => {
    const i = a.Children.toArray(e)[0];
    if (a.isValidElement(i) && i.type !== void 0) {
      const {
        displayName: g
      } = i.type;
      ["RangoButtonIcon", "RangoRadioButton", "RangoCheckbox"].includes(g) && c(!1);
    }
  };
  return /* @__PURE__ */ o(u, { ref: d, $isCompact: t, $fixed: r, $paddingLg: l, ...n, children: /* @__PURE__ */ o("span", { children: e }) });
});
L.displayName = "RangoTableHead";
export {
  T as RangoTable,
  N as RangoTableCell,
  L as RangoTableHead,
  $ as RangoTableRow,
  b as TablePropsDensity
};
